import React from "react";
import { X } from "lucide-react";

interface Product {
  id: string;
  productName: string;
  quantity: string;
}

interface ViewRequestedProductsModalProps {
  isOpen: boolean;
  onClose: () => void;
  products: Product[];
}

const ViewRequestedProductsModal: React.FC<ViewRequestedProductsModalProps> = ({
  isOpen,
  onClose,
  products,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg w-full max-w-2xl max-h-[80vh] flex flex-col">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-semibold">Requested Products</h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded">
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="p-4 flex-1 overflow-y-auto">
          {products && products.length > 0 ? (
            <div className="border rounded-lg overflow-hidden">
              <table className="w-full">
                <thead className="bg-gray-50 border-b">
                  <tr>
                    <th className="text-left p-3 font-medium text-gray-600 w-16">
                      S.No.
                    </th>
                    <th className="text-left p-3 font-medium text-gray-600">
                      Product Name
                    </th>
                    <th className="text-left p-3 font-medium text-gray-600">
                      Quantity
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {products.map((item, index) => (
                    <tr key={index}>
                      <td className="p-3 text-sm text-gray-500 font-medium">{index + 1}</td>
                      <td className="p-3 text-gray-800">{item.productName}</td>
                      <td className="p-3 text-gray-800">{item.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-center text-gray-500 py-8">
              No products found in this request.
            </p>
          )}
        </div>

        <div className="p-4 border-t flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewRequestedProductsModal;
